import {  ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';

@Component({
    selector: 'clever-preisealarmselectedfilters',
    templateUrl: './preisealarmselectedfilters.component.html',
    styleUrls: ['./preisealarmselectedfilters.component.scss'],
    standalone: false
})
export class PreisealarmselectedfiltersComponent implements OnInit {
    @Input() filter: ParamFilters;
    @Input() mode: string;
    list: string[] = [];
    slice: number = 5;
    constructor(
        protected cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.list = [];
        this.cdr.markForCheck();
        this.checkPrc();
        this.checkInclusiveListServiceOffer();
        this.checkflightCarrierList();
        this.checktransferlist();
        this.checkarrivalAirportList();
        this.checkreturnTime();
        this.checkdepartureTime();

        this.checkMeerblibk();
        this.checkMeerseite();
        this.checklocationCode();
        this.checkboardTypeList();
        this.checkdirektflug();
        this.checktarifclass();
        this.checkbookingclass();
        this.checkTravelClass();
        this.checkinclusiveList();
        this.checkFacilityList();
        this.checkroomTypeList();
        this.checkroomIdList();
        this.checktourOperatorList();
        this.checkhotelChainList();
    }

    showList(vl) {
        this.slice = vl;
    }

    checkPrc(): void {
        if (this.filter?.minPricePerPerson > 0) {
            this.list.push('min ' + this.filter?.minPricePerPerson + ' € p.P.');
            this.cdr.markForCheck();
        }
        if (this.filter?.maxPricePerPerson > 0) {
            this.list.push('max ' + this.filter?.maxPricePerPerson + ' € p.P.');
            this.cdr.markForCheck();
        }
    }

    checkInclusiveListServiceOffer(): void {
        if (this.filter?.inclusiveListServiceOffer?.length > 0) {
            for (let i = 0; i < this.filter?.inclusiveListServiceOffer.length; i++) {
                this.list.push(this.filter?.inclusiveListServiceOffer[i].name);
            }
        }
    }

    checkMeerblibk(): void {
        if (this.filter?.zommermitmeerblick) {
            this.list.push('Meerblick');
        }
    }

    checkMeerseite(): void {
        if (this.filter?.meerseite) {
            this.list.push('Meerseite');
        }
    }

    checkboardTypeList(): void {
        if (this.filter?.boardTypeList?.length > 0) {
            for (let i = 0; i < this.filter?.boardTypeList.length; i++) {
                this.list.push(this.filter?.boardTypeList[i].name);
            }
        }
    }

    checklocationCode(): void {
        if (this.filter?.locatedList?.length > 0) {
            for (let i = 0; i < this.filter?.locatedList.length; i++) {
                this.list.push(this.filter?.locatedList[i].name);
            }
        }
    }

    checktransferlist(): void {
        if (this.filter?.transferlist?.length > 0) {
            for (let i = 0; i < this.filter?.transferlist.length; i++) {
                if (this.filter?.transferlist[i] === 'MT') {
                    this.list.push('mit Transfer');
                } else if (this.filter?.transferlist[i] === 'OT') {
                    this.list.push('ohne Transfer');
                } else if (this.filter?.transferlist[i] === 'MW') {
                    this.list.push('Mietwagen');
                } else if (this.filter?.transferlist[i] === 'ZG') {
                    this.list.push('Zug zum Flug');
                }
            }
        }
    }

    checkdirektflug(): void {
        if (this.filter?.flight?.directness === 'N') {
            this.list.push('Direktflug');
        } else if (this.filter?.flight?.stopover === '1') {
            this.list.push('max 1 Stopp');
        } else if (this.filter?.flight?.stopover === '2') {
            this.list.push('max 1 Stopp');
        }
    }

    checktarifclass(): void {
        if (this.filter?.flight?.tariff === 'SPAR') {
            this.list.push('Sparpreis');
        }
        if (this.filter?.flight?.tariff === 'FLEX') {
            this.list.push('Flexpreis');
        }
    }

    checkbookingclass(): void {
        if (this.filter?.flight?.bookingClass === '1') {
            this.list.push('1. Klasse');
        }
        if (this.filter?.flight?.bookingClass === '2') {
            this.list.push('2. Klasse');
        }
    }

    checkTravelClass(): void {
        if (this.filter?.flight?.travelClass === 'economy') {
            this.list.push('Flugklasse: Economy');
        } else if (this.filter?.flight?.travelClass === 'premium') {
            this.list.push('Flugklasse: Premium Eco');
        } else if (this.filter?.flight?.travelClass === 'business') {
            this.list.push('Flugklasse: Business');
        } else if (this.filter?.flight?.travelClass === 'first') {
            this.list.push('Flugklasse: First');
        }
    }

    checkinclusiveList(): void {
        if (this.filter?.inclusiveList?.length > 0) {
            for (let i = 0; i < this.filter?.inclusiveList.length; i++) {
                this.list.push(this.filter?.inclusiveList[i].name);
            }
        }
    }

    checkFacilityList(): void {
        if (this.filter?.facilityList?.length > 0) {
            for (let i = 0; i < this.filter?.facilityList.length; i++) {
                this.list.push(this.filter?.facilityList[i].name);
            }
        }
    }

    checkroomTypeList(): void {
        if (this.filter?.roomTypeList?.length > 0) {
            for (let i = 0; i < this.filter?.roomTypeList.length; i++) {
                this.list.push(this.filter?.roomTypeList[i].name);
            }
        }
    }

    checkroomIdList(): void {
        if (this.filter?.roomIdList?.length > 0) {
            for (let i = 0; i < this.filter?.roomIdList.length; i++) {
                this.list.push(this.filter?.roomIdList[i].name + ' (' + this.filter?.roomIdList[i].code + ')');
            }
        }
    }

    checktourOperatorList(): void {
        if (this.filter?.tourOperatorList?.length > 0) {
            for (let i = 0; i < this.filter?.tourOperatorList.length; i++) {
                this.list.push(this.filter?.tourOperatorList[i].code);
            }
        }
    }

    checkarrivalAirportList(): void {
        if (this.filter?.arrivalAirportList?.length > 0) {
            for (let i = 0; i < this.filter?.arrivalAirportList.length; i++) {
                this.list.push('Ziel ' + this.filter?.arrivalAirportList[i].name + ' ' + this.filter?.arrivalAirportList[i].code);
            }
        }
    }

    checkhotelChainList(): void {
        if (this.filter?.hotelChainList?.length > 0) {
            for (let i = 0; i < this.filter?.hotelChainList.length; i++) {
                this.list.push(this.filter?.hotelChainList[i].name);
            }
        }
    }

    checkflightCarrierList(): void {
        if (this.filter?.flightCarrierList?.length > 0) {
            for (let i = 0; i < this.filter?.flightCarrierList.length; i++) {
                this.list.push(this.filter?.flightCarrierList[i].name);
            }
        }
    }

    checkdepartureTime(): void {
        let text = '';
        if (this.filter?.mindepartureTime > 0 && this.filter?.mindepartureTime < 1440) {
            text = this.transformMinute(this.filter?.mindepartureTime);
        }
        if (this.filter?.maxdepartureTime > 0 && this.filter?.maxdepartureTime < 1440) {
            if (text?.length > 0) {
                text += '-' + this.transformMinute(this.filter?.maxdepartureTime);
            } else {
                text = 'vor ' + this.transformMinute(this.filter?.maxdepartureTime);
            }
        } else if (text?.length > 0) {
            text = 'nach ' + text;
        }
        if (text?.length > 0) {
            this.list.push('Hinflugzeit ' + text);
        }
    }

    transformMinute(value: number): string {
        const hours = ('00' + Math.floor(value / 60)).slice(-2);
        const minutes = ('00' + Math.floor(value % 60)).slice(-2);
        return hours + ':' + minutes;
    }

    checkreturnTime(): void {
        let text = '';
        if (this.filter?.minreturnTime > 0 && this.filter?.minreturnTime < 1440) {
            text = this.transformMinute(this.filter?.minreturnTime);
        }
        if (this.filter?.maxreturnTime > 0 && this.filter?.maxreturnTime < 1440) {
            if (text?.length > 0) {
                text += '-' + this.transformMinute(this.filter?.maxreturnTime);
            } else {
                text = 'vor ' + this.transformMinute(this.filter?.maxreturnTime);
            }
        } else if (text?.length > 0) {
            text = 'nach ' + text;
        }
        if (text?.length > 0) {
            this.list.push('Rückflugzeit ' + text);
        }
    }
}
